import Inspector from './inspector';
import SvgArrow from '../../../images/SvgArrow';

const { RichText } = wp.blockEditor;

const staticDefaultImage = 'https://via.placeholder.com/35?text=35';

const Edit = ({ attributes, setAttributes }) => {
  const { cardText, icon, variant } = attributes;

  return (
    <>
      <Inspector attributes={attributes} setAttributes={setAttributes} />

      <a className={`SelfServiceCard__item ${variant}`}>
        <figure className="SelfServiceCard__item--icon">
          <img src={icon.src || staticDefaultImage} />
        </figure>

        <RichText
          className="SelfServiceCard__item--text"
          tagName="p"
          value={cardText}
          placeholder="Texto aqui"
          keepPlaceholderOnFocus
          onChange={(cardText) => setAttributes({ cardText })}
        />
      </a>

      {variant === 'default' && (
        <div className="SelfServiceCard__item--arrow">
          <SvgArrow />
        </div>
      )}
    </>
  );
};

export default Edit;
